module.exports = __webpack_public_path__ + "static/media/sccl.67097131.jpeg";